import { render, staticRenderFns } from "./login.vue?vue&type=template&id=4a308a6e&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLogo: require('/opt/cargo.front/src/components/base/logo.vue').default,AuthLoginForm: require('/opt/cargo.front/src/components/auth/login-form.vue').default})
